export default __webpack_public_path__ + "static/media/snip.7c42982b.png";